import SigninVerify from "../../../../jsx/pages/Customer/SigninVerify";

const SigninVerifyWrapper = function (props) {
  return <SigninVerify />;
};

export default constore(SigninVerifyWrapper);
